import {
  SET_ADMIN_LIST,
  SET_ADMIN_STATUS,
  SET_DISABLED_ADMIN_LIST,
  SET_AGENT_LIST,
  SET_AGENT_SEARCHING,
  SET_ZENTAO_URL,
  SET_ALL_ROLE,
  SET_SEARCH_ROLE,
  SET_ADMIN_IS_OUTSIDE,
} from './mutation-type'
import api from '@/api'
import {objectTrim} from '@/utils'

const state = {
  searching: false,
  adminList: [],
  disabledAdminList: [],
  status: 0,
  isOutside: 0,
  agentList: [],
  zentaoUrl: '',
  allRoles: [],
  searchRoles: [],
  searchRoleInput: '',
  isSearchRole: false,
}

const mutations = {
  [SET_ADMIN_LIST] (state, payload) {
    state.adminList = payload
  },
  [SET_AGENT_LIST] (state, payload) {
    state.agentList = payload
  },
  [SET_DISABLED_ADMIN_LIST] (state, payload) {
    state.disabledAdminList = payload
  },
  [SET_ADMIN_STATUS] (state, payload) {
    state.status = payload
  },
  [SET_ADMIN_IS_OUTSIDE] (state, payload) {
    state.isOutside = payload
  },
  [SET_AGENT_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_ZENTAO_URL] (state, payload) {
    state.zentaoUrl = payload
  },
  [SET_ALL_ROLE] (state, payload) {
    state.allRoles = payload
  },
  [SET_SEARCH_ROLE] (state, payload) {
    state.searchRoleInput = payload.searchRoleInput
    state.searchRoles = payload.searchRoles
    state.isSearchRole = payload.isSearchRole
  },
}

const actions = {
  // 管理员列表
  async getAdminList ({commit, dispatch}, payload) {
    const data = await api.adminApi.queryAdminList(payload)
    dispatch('setStatus', payload.status)
    dispatch('setIsOutside', payload.isOutside)
    if (data.result && data.code === 200) {
      if (payload.status === 0) {
        commit(SET_ADMIN_LIST, data.data)
      } else {
        commit(SET_DISABLED_ADMIN_LIST, data.data)
      }
    }
  },
  // 修改禁用状态
  setStatus ({commit, dispatch}, status) {
    commit(SET_ADMIN_STATUS, status)
  },
  setIsOutside({commit}, isOutside) {
    commit(SET_ADMIN_IS_OUTSIDE, isOutside)
  },
  // 新增管理员
  async addAdmin ({dispatch, state}, payload) {
    const data = await api.adminApi.addAdmin(payload)
    if (data.result && data.code === 200) {
      dispatch('getAdminList', {status: state.status, isOutside: state.isOutside})
    }
    return data
  },
  // 更新管理员
  async updateAdmin ({dispatch, state}, payload) {
    const data = await api.adminApi.updateAdmin(payload)
    if (data.result && data.code === 200) {
      dispatch('getAdminList', {status: state.status, isOutside: state.isOutside})
    }
    return data
  },
  // 用户数据清除
  async cleanAdminUserData ({dispatch, state}, { payload, callback }) {
    const data = await api.adminApi.cleanAdminUserData(payload)
    if (data.result && data.code === 200) {
      if (callback) {
        callback()
      }
      // dispatch('getAdminList', {status: state.status, isOutside: state.isOutside})
    }
    return data
  },
  // 根据管理员id获取所有的权限
  async queryRoleListByAdminId () {
    const data = await api.adminApi.queryRoleListByLoginAdminId()
    return data.data === null ? [] : data.data
  },
  // 获取所有部门
  async queryOrganizationList () {
    const data = await api.adminApi.queryOrganizationList()
    return data.data === null ? [] : data.data
  },
  // 获取职位
  // eslint-disable-next-line
  async queryPositionList ({}, payload) {
    const data = await api.adminApi.queryPositionListByOrganizationId(payload)
    return data.data === null ? [] : data.data
  },
  // 验证用户名是否已存在
  // eslint-disable-next-line
  async validateAdminName ({}, payload) {
    const data = await api.adminApi.validateAdminName(payload)
    return data
  },
  // 验证管理员手机号是否存在
  // eslint-disable-next-line
  async validateAdminPhone ({}, payload) {
    const data = await api.adminApi.validateAdminPhone(payload)
    return data
  },
  // 验证管理员邮箱是否存在
  // eslint-disable-next-line
  async validateAdminEmail ({}, payload) {
    const data = await api.adminApi.validateAdminEmail(payload)
    return data
  },
  // 根据id查询管理员基础信息
  async queryAdminBase () {
    const data = await api.adminApi.queryAdminBase()
    return data.data === null ? [] : data.data
  },
  // 代理列表
  // eslint-disable-next-line
  async getAgentList ({}, payload = {}) {
    const {data} = await api.adminApi.queryAgentList(objectTrim(payload))
    return data
  },
  // 获取代理详情信息
  // eslint-disable-next-line
  async getAgentInfo ({}, payload) {
    let param = {
      ...payload,
    }
    const {data} = await api.adminApi.queryAgentList(param)
    if (data.length !== 0) {
      let row = data[0]
      let roleIds = []
      let roleNames = []
      if (row.adminRoleInfoList !== null) {
        row.adminRoleInfoList.forEach(e => {
          roleIds.push(e.roleId)
          roleNames.push(e.roleName)
        })
      }
      let params = {
        agentId: row.id,
        inviteKey: row.inviteKey,
        loginName: row.loginName,
        loginPassword: '',
        reallyName: row.reallyName,
        phone: row.phone,
        email: row.email,
        areaId: row.areaId,
        remark: row.remark,
        roleIds: roleIds,
        roleNames: roleNames,
        initCustomerRole: row.initCustomerRole,
        initPicturePro: row.initPicturePro,
        initCouponBalance: row.initCouponBalance,
        taskGroup: row.taskGroup,
        taskLevelDefault: row.taskLevelDefault,
        taskProperties: row.taskProperties,
        taskRequirements: row.taskRequirements,
        renderConstraint: row.renderConstraint,
        agentGpuPrice: row.agentGpuPrice,
        agentCpuPrice: row.agentCpuPrice,
        customPriceFlag: row.customPriceFlag,
        initCouponTermDays: row.initCouponTermDays,
        businessType: row.businessType,
        country: row.country,
      }
      return params
    }
    return false
  },
  // 新增代理
  async addAgent ({dispatch, state}, payload) {
    const data = await api.adminApi.addAgent(payload)
    return data
  },
  // 更新代理
  async updateAgent ({dispatch, state}, payload) {
    const data = await api.adminApi.updateAgent(payload)
    return data
  },
  // 给代理分配业务
  async allocateAgentAdmin ({dispatch}, payload) {
    const {result, message, code} = await api.adminApi.allocateAgentAdmin(payload)
    return {result, message, code}
  },
  // 给代理充值
  async rechargeAgent ({dispatch}, payload) {
    const {result, message, code} = await api.adminApi.rechargeAgent(payload)
    return {result, message, code}
  },
  // 更新用户资料信息
  async updateAdminBase ({state}, payload) {
    const data = await api.adminApi.updateAdminBase(payload)
    return data
  },
  async getCompanyAndOrgs ({state, commit}) {
    const {data} = await api.financeApi.getCompanyAndOrgs()
    return data
  },
  // zentao 登入入口
  async getZentaoLoginUrl ({state, commit}) {
    const data = await api.adminApi.getZentaoLoginUrl()
    if (data.code === 200) commit(SET_ZENTAO_URL, data.data)
    return data
  },
  // 获取所有权限
  async queryRoleList ({commit}) {
    const result = await api.adminApi.queryRoleList()
    if (result.code === 200) commit(SET_ALL_ROLE, result.data)
    return result
  },
  // 更新权限名称搜索结果
  updateRoleSearch({commit}, payload) {
    commit(SET_SEARCH_ROLE, payload)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
